import React, {useCallback, useMemo, useState} from 'react';
import {ConfigProvider, Layout, Menu, theme} from 'antd';
import {
    AreaChartOutlined,
    BankOutlined,
    BarcodeOutlined,
    EuroCircleOutlined,
    FileImageOutlined,
    HomeOutlined,
    LeftOutlined,
    RightOutlined,
    ScheduleOutlined,
    TeamOutlined
} from '@ant-design/icons';
import s from './main.module.css';
import {NewStaff} from "../staff/Staff";
import {NewRules} from "../rules/Rules";
import ObjectsGeneral from "../objects/ObjectsGeneral";
import Home from "../home/Home";
import AnaliticsGeneral from "../analitics/AnaliticsGeneral";
import PhotoArchive from "../photo/PhotoArchive";
import TestPlanSend from "../test/testPlanSend";
import {NewStore} from "../store/Store";
import NewPlanning from "../new_planning/NewPlanning";
import PlanList from "../planslist/PlansList";
import MaintenanceReports from "../new_reports/MaintenanceReports";
import IncomeDashboard from "../analitics/IncomeDashboard";
import WorksDashboard from "../analitics/objects/WorksDashboard";
import StaffAnalytics from "../analitics/StaffAnalytics";
import ReportsDashboard from "../analitics/works/ReportsDashboard";
import Expenses from "../finance/components_041425/Expenses";
import Dashboard from "../finance/Dashboard";
import IncomePeriodic from "../finance/components_041425/IncomePeriodic";
import OneTimeIncome from "../finance/components_041425/OneTimeIncome";

const {Content, Sider} = Layout;

const MainMenu = ({user, roles}) => {
    const [collapsed, setCollapsed] = useState(false);
    const [page, setPage] = useState('1');
    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    const onCollapse = useCallback(() => {
        setCollapsed(prev => !prev);
    }, []);

    const handlePageChange = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    // Мемоизированные элементы меню
    const menuItems = useMemo(() => {
        const items = [
            {
                key: '1',
                icon: <HomeOutlined/>,
                label: 'Главная',
                onClick: () => handlePageChange('1')
            }
        ];

        // Сотрудники
        if (roles.isAdmin) {
            items.push({
                key: 'sub1',
                icon: <TeamOutlined/>,
                label: 'Сотрудники',
                children: [
                    {
                        key: '11',
                        label: 'Список',
                        onClick: () => handlePageChange('11')
                    },
                    {
                        key: '12',
                        label: 'Роли',
                        onClick: () => handlePageChange('12')
                    },
                ]
            });
        }

        // Склад
        if (roles.isAdmin || roles.isStoreAccess) {
            items.push({
                key: 'sub2',
                icon: <BarcodeOutlined/>,
                label: 'Склад',
                children: [
                    {
                        key: '21',
                        label: 'Склад',
                        onClick: () => handlePageChange('21')
                    },
                ]
            });
        }

        // Планирование
        if (roles.isAdmin || roles.isPlanningAccess) {
            items.push({
                key: 'sub3',
                icon: <ScheduleOutlined/>,
                label: 'Планирование',
                children: [
                    {
                        key: '31',
                        label: 'Создать новый план',
                        onClick: () => handlePageChange('31')
                    },
                    {
                        key: '34',
                        label: 'Редактировать текущий план',
                        onClick: () => handlePageChange('34')
                    },
                    {
                        key: '32',
                        label: 'Просмотр планов',
                        onClick: () => handlePageChange('32')
                    },
                ]
            });
        }

        // Объекты
        if (roles.isAdmin || roles.isPlanningAccess) {
            items.push({
                key: 'sub4',
                icon: <BankOutlined/>,
                label: 'Объекты',
                children: [
                    {
                        key: '41',
                        label: 'Список объектов',
                        onClick: () => handlePageChange('41')
                    },
                    {
                        key: '42',
                        label: 'Отчеты',
                        onClick: () => handlePageChange('42')
                    }
                ]
            });
        }

        // Финансы
        if (roles.isAdmin) {
            items.push({
                key: 'sub5',
                icon: <EuroCircleOutlined/>,
                label: 'Финансы',
                children: [
                    {
                        key: '51',
                        label: 'Сводка',
                        onClick: () => handlePageChange('51')
                    },
                    {
                        key: '53',
                        label: 'Периодические доходы',
                        onClick: () => handlePageChange('53')
                    },
                    {
                        key: '54',
                        label: 'Разовые доходы',
                        onClick: () => handlePageChange('54')
                    },
                    {
                        key: '55',
                        label: 'Расходы',
                        onClick: () => handlePageChange('55')
                    }
                ]
            });
        }

        // Фото Архив
        if (roles.isAdmin) {
            items.push({
                key: '7',
                icon: <FileImageOutlined/>,
                label: 'Фото Архив',
                onClick: () => handlePageChange('7')
            });
        }

        // Аналитика
        if (roles.isAdmin) {
            items.push({
                key: 'sub6',
                icon: <AreaChartOutlined/>,
                label: 'Аналитика',
                children: [
                    {
                        key: '61',
                        label: 'Выгрузки',
                        onClick: () => handlePageChange('61')
                    },
                    {
                        key: '62',
                        label: 'Аналитика доходов',
                        onClick: () => handlePageChange('62')
                    },
                    {
                        key: '63',
                        label: 'Аналитика объектов',
                        onClick: () => handlePageChange('63')
                    },
                    {
                        key: '64',
                        label: 'Аналитика сотрудников',
                        onClick: () => handlePageChange('64')
                    },
                    /*                    {
                                            key: '65',
                                            label: 'Аналитика работ',
                                            onClick: () => handlePageChange('65')
                                        }*/
                ]
            });
        }

        // Кнопка скрытия/показа
        items.push({
            key: 'collapse',
            icon: collapsed ? <RightOutlined/> : <LeftOutlined/>,
            label: collapsed ? 'Развернуть' : 'Свернуть',
            onClick: onCollapse,
            className: s.collapseButton
        });

        return items;
    }, [roles, handlePageChange, onCollapse, collapsed]);

    // Мемоизированный рендеринг контента
    const renderContent = useMemo(() => {
        const contentMap = {
            '99': <TestPlanSend/>,
            '1': <Home/>,
            '7': <PhotoArchive/>,
            '11': <NewStaff style={{padding: 20}} setPage={handlePageChange}/>,
            '12': <NewRules setPage={handlePageChange}/>,
            '21': <NewStore page="21" username={user.login}/>,
            '41': <ObjectsGeneral mainPage="41"/>,
            '42': <MaintenanceReports mainPage="42"/>,
            '31': <NewPlanning edit={false} setPage={handlePageChange}/>,
            '34': <NewPlanning edit={true}/>,
            '32': <PlanList/>,
            '51': <Dashboard/>,
            '54': <OneTimeIncome setPage={handlePageChange} page="54"/>,
            '53': <IncomePeriodic/>,
            '55': <Expenses setPage={handlePageChange} page="55"/>,
            '61': <AnaliticsGeneral/>,
            '62': <IncomeDashboard/>,
            '63': <WorksDashboard/>,
            '64': <StaffAnalytics/>,
            '65': <ReportsDashboard/>,
        };

        return contentMap[page] || <Home/>;
    }, [page, handlePageChange, user.login]);

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#1890ff',
                borderRadius: 8,
            },
        }}>
            <Layout style={{userSelect: 'none'}}>
                <Sider
                    collapsible
                    trigger={null}
                    breakpoint="lg"
                    collapsedWidth="60"
                    collapsed={collapsed}
                    onCollapse={onCollapse}
                    style={{
                        overflow: 'auto',
                        height: '100vh',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        zIndex: 0
                    }}
                    width={250}
                >
                    <div className={s.logoContainer}></div>
                    <Menu
                        theme="dark"
                        selectedKeys={[page]}
                        mode="inline"
                        items={menuItems}
                        style={{borderRight: 0, flex: 1}}
                        inlineCollapsed={collapsed}
                    />
                    {!collapsed && <div className={s.footer__text}>
                        {`Garden Design App©${new Date().getFullYear()}`}
                        <div>Created by A.Rasanen</div>
                    </div>}

                </Sider>
                <Layout style={{
                    marginLeft: collapsed ? 60 : 250,
                    transition: 'margin-left 0.2s',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Content style={{
                        padding: '16px',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0 // Критически важно для flex + overflow
                    }}>
                        <div
                            style={{
                                padding: 24,
                                background: colorBgContainer,
                                borderRadius: borderRadiusLG,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'auto',
                                minHeight: 0 // Критически важно
                            }}
                        >
                            <div style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: 0
                            }}>
                                {renderContent}
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default MainMenu;